import getSortObjForCol from '../../../../utility/getSortObjForCol';
import { appliedReportSelectors } from '../report/applied';

const getDataset = (state) => state.playersAndTeams.dataTable.dataset;
const getSort = (state) => state.playersAndTeams.dataTable.sort;
const getPage = (state) => state.playersAndTeams.dataTable.page;
const getPageSize = (state) => state.playersAndTeams.dataTable.pageSize;

/*
 * The default sorting for 'daysbetweengames' is different aggregated vs non aggregated
 */
const getDefaultSort = (reportState, reportData) => {
    const columnMapper =
        reportState.reportName === 'daysbetweengames' && appliedReportSelectors.isAggregatedReport(reportState)
            ? { teamFullName: 'franchiseName' }
            : {};
    return reportData.sortKeys.map((col) =>
        columnMapper[col] ? getSortObjForCol(columnMapper[col]) : getSortObjForCol(col),
    );
};

/* getSortAsQueryParams
 *
 * Transforms the columns used for sorting into query parameters to use in a cayenne espression.
 * sortInfo is sorting data that has already been transformed to be HANA appropriate
 */
const getSortAsQueryParams = (reportCategory, sortState, appliedReport) => {
    /**
     * If we are sorting by skaterFullName or goalieFullName we will
     * add in an additional sort by lastName before the fullName sort
     */
    const sortInfo = [...sortState];
    const fullNameIndex = sortInfo.findIndex((col) => {
        if (col.id === 'skaterFullName' || col.id === 'goalieFullName') {
            return col;
        }
    });
    const lastNameExist = sortInfo.some((col) => col.id === 'lastName');
    if (fullNameIndex !== -1 && !lastNameExist) {
        const lastNameSort = {
            id: 'lastName',
            desc: sortInfo[fullNameIndex].desc,
        };
        sortInfo.splice(fullNameIndex, 0, lastNameSort);
    }

    const caseInsensitiveColumns = ['lastName', 'goalieFullName', 'skaterFullName'];
    const sortData = sortInfo.map((col) => {
        if (caseInsensitiveColumns.includes(col.id)) {
            return {
                property: col.id,
                direction: col.desc ? 'DESC_CI' : 'ASC_CI',
            };
        }
        return {
            property: col.id,
            direction: col.desc ? 'DESC' : 'ASC',
        };
    });

    let playerTeamKey = 'playerId';
    if (reportCategory === 'team') {
        playerTeamKey = appliedReportSelectors.isAggregatedReport(appliedReport) ? 'franchiseId' : 'teamId';
    }
    const playerTeamExist = sortInfo.find((col) => col.id === playerTeamKey);
    if (!playerTeamExist) {
        sortData.push({
            property: playerTeamKey,
            direction: 'ASC',
        });
    }

    return sortData.length > 0 ? `sort=${JSON.stringify(sortData)}` : '';
};

const getSortAsDeeplinkParams = (sortInfo) => {
    if (sortInfo.length === 0) {
        return '';
    }

    const sortData = sortInfo
        .map((col) => {
            if (col.desc === false) {
                return 'a_' + col.id;
            }
            return col.id;
        })
        .join(',');

    return `sort=${sortData}`;
};

const getPaginationAsQueryParams = (page, pageSize) => [`start=${page * pageSize}`, `limit=${pageSize}`];

const getPaginationAsDeeplinkParams = (page, pageSize) => [`page=${page}`, `pageSize=${pageSize}`];

export default {
    getDataset,
    getDefaultSort,
    getSortAsQueryParams,
    getSortAsDeeplinkParams,
    getSort,
    getPage,
    getPageSize,
    getPaginationAsQueryParams,
    getPaginationAsDeeplinkParams,
};
